export default "__VITE_ASSET__6e0f1e3f__"